export const TABS = {
  GENERAL: 'General',
  SANDBOX: 'Sandbox',
  MARKETPLACE: 'Marketplace Listing',
  METRICS: 'Metrics',
};
